module.exports = __webpack_public_path__ + "static/logo-443da5d6f9e644bad130fa4a0da32420.svg";